module.exports = __webpack_public_path__ + "static/img/logo@2x.96908cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/project-logos/logo@2x.png
// module id = lMB4
// module chunks = 0